import { media, styled, zIndexes } from "@iventis/styles";
import { Content } from "@iventis/translations/content/typed-content";
import { Card } from "@mui/material";
import React, { FunctionComponent } from "react";
import { Body2, Header5 } from "@iventis/styles/src/components/texts";
import { SavedMapView } from "@iventis/domain-model/model/savedMapView";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { FormButtonsComponent, StyledDialogActions } from "@iventis/components";

interface MapViewsProps {
    existingMapView: SavedMapView; // If existing saved map view, it will not be null
    submit: () => void;
    cancel: () => void;
}

export const MapViewsPopper: FunctionComponent<MapViewsProps> = ({ existingMapView = null, submit, cancel }) => {
    const translate = useIventisTranslate();
    const header = existingMapView ? `${translate(Content.map.saved_map_view.edit_saved_view)}: ${existingMapView?.name}` : translate(Content.map.saved_map_view.create_saved_view);
    const textLine1 = translate(Content.map.saved_map_view.move_map_around);
    const textLine2 = translate(Content.map.saved_map_view.save_view_when_ready);

    return (
        <MapViewContainer>
            <Header5>{header}</Header5>
            <Body2>{textLine1}</Body2>
            <Body2>{textLine2}</Body2>

            <StyledDialogActions>
                <FormButtonsComponent
                    submitButtonText={translate(Content.common.buttons.save)}
                    handleSubmit={submit}
                    secondaryButtons={[{ buttonText: translate(Content.common.buttons.cancel), onButtonPressed: cancel }]}
                />
            </StyledDialogActions>
        </MapViewContainer>
    );
};

const MapViewContainer = styled(Card)`
    padding: 20px;
    width: 90%;
    ${media.small} {
        width: 500px;
        // needs to be above drawing toolbar
        z-index: ${zIndexes.drawingToolbar + 1};
    }
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translate(-50%, 0%);
`;
